import { useState, useEffect, useRef } from 'react';

interface Review {
  id: number;
  name: string;
  rating: number;
  text: string;
  avatar: string;
}

const reviews: Review[] = [
  {
    id: 1,
    name: 'Jeremias Audisio',
    rating: 5,
    text: '¡Me encuentro realmente conforme! Recibí muy buen asesoramiento por parte del estudio. Super recomendable, pero sobre todo por la empatía y empeño con el que laburan para llevar adelante tu causa.',
    avatar: 'JA',
  },
  {
    id: 2,
    name: 'Santiago Calcagno',
    rating: 5,
    text: 'Excelente profesional. La Dra. Valentina Amigo fue muy clara y eficiente, me resolvió todo rápido y con mucha dedicación. Súper recomendable.',
    avatar: 'SC',
  },
  {
    id: 3,
    name: 'Maria Gabriela Rodriguez',
    rating: 5,
    text: 'Gracias Valentina por todo el asesoramiento, excelente profesional. Su orientación fue clave para tomar decisiones informadas. Muy recomendable, además de súper clara y comprometida',
    avatar: 'MGR',
  },
  {
    id: 4,
    name: 'Fede Vieytes',
    rating: 5,
    text: 'Gran profesional y muy buen asesoramiento legal. Recomiendo mucho',
    avatar: 'FV',
  },
  {
    id: 5,
    name: 'Facundo Marino',
    rating: 5,
    text: 'muy piola y graciosa vale',
    avatar: 'FM',
  },
  {
    id: 6,
    name: 'Juli Rossa',
    rating: 5,
    text: 'Recomiendo. Asesoramiento muy completo por parte de Valentina! Gran profesional.',
    avatar: 'JR',
  },
  {
    id: 7,
    name: 'Micaela Ferreyra',
    rating: 5,
    text: '',
    avatar: 'MF',
  },
  {
    id: 8,
    name: 'Coti Mathieu',
    rating: 5,
    text: 'Muy buena profesional',
    avatar: 'CM',
  },
  {
    id: 9,
    name: 'Aldana Maldonado',
    rating: 5,
    text: '¡Excelente profesional!',
    avatar: 'AM',
  },
  {
    id: 10,
    name: 'Maria Sol Nasi',
    rating: 5,
    text: 'Muy buen asesoramiento!',
    avatar: 'MS',
  },
  {
    id: 11,
    name: 'Nacho Rossa',
    rating: 5,
    text: 'Me solucionaron rápido, muy profesional y claro. Excelente',
    avatar: 'NR',
  },
  {
    id: 12,
    name: 'Candela Meyer',
    rating: 5,
    text: 'Excelente experiencia. Desde el primer momento tuvo una atención impecable y muy profesional. Me ayudó a resolver todo lo relacionado con un accidente en el que me chocaron, explicándome cada paso con claridad y ocupándose de las gestiones de forma rápida y correcta. Destaco no solo su conocimiento y compromiso, sino también el seguimiento posterior, incluso después de que el auto estuvo arreglado, asegurándose de que todo quedara realmente solucionado. Me sentí acompañada y tranquila durante todo el proceso. La recomiendo totalmente.',
    avatar: 'CM',
  },
];

function StarRating({ rating }: { rating: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: 5 }).map((_, i) => (
        <span key={i} className="w-4 h-4 flex items-center justify-center">
          <i
            className={`ri-star-fill text-sm ${
              i < rating ? 'text-[#FBBC04]' : 'text-white/20'
            }`}
          ></i>
        </span>
      ))}
    </div>
  );
}

export default function ReviewsSection() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visibleCount, setVisibleCount] = useState(3);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    const updateVisible = () => {
      if (window.innerWidth < 768) {
        setVisibleCount(1);
      } else if (window.innerWidth < 1024) {
        setVisibleCount(2);
      } else {
        setVisibleCount(3);
      }
    };
    updateVisible();
    window.addEventListener('resize', updateVisible);
    return () => window.removeEventListener('resize', updateVisible);
  }, []);

  const maxIndex = Math.max(0, reviews.length - visibleCount);

  const startAutoPlay = () => {
    if (intervalRef.current) clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      setCurrentIndex((prev) => (prev >= maxIndex ? 0 : prev + 1));
    }, 5000);
  };

  useEffect(() => {
    startAutoPlay();
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [maxIndex]);

  const goTo = (index: number) => {
    setCurrentIndex(index);
    startAutoPlay();
  };

  const goPrev = () => {
    goTo(currentIndex <= 0 ? maxIndex : currentIndex - 1);
  };

  const goNext = () => {
    goTo(currentIndex >= maxIndex ? 0 : currentIndex + 1);
  };

  const averageRating = (
    reviews.reduce((sum, r) => sum + r.rating, 0) / reviews.length
  ).toFixed(1);

  return (
    <section id="resenas" className="py-10 md:py-14 bg-[#111e30]">
      <div className="max-w-7xl mx-auto px-5 md:px-6 lg:px-20">
        {/* Header */}
        <div className="text-center mb-6 md:mb-8">
          <div className="inline-flex items-center gap-2 border border-[#B89A5A]/30 rounded-full px-4 py-1.5 mb-3 md:mb-4">
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-google-fill text-[#B89A5A] text-xs"></i>
            </span>
            <span className="text-[#B89A5A] text-xs font-medium tracking-wider">
              RESEÑAS DE GOOGLE
            </span>
          </div>
          <h2 className="text-2xl md:text-3xl font-serif font-bold text-white mb-2">
            Lo que dicen nuestros clientes
          </h2>
          <p className="text-sm md:text-base text-white/60 max-w-2xl mx-auto mb-4">
            La confianza de quienes nos eligen es nuestro mayor respaldo
          </p>

          {/* Overall Rating */}
          <div className="inline-flex items-center gap-2.5 bg-[#14253D]/50 border border-white/10 rounded-full px-4 py-2">
            <span className="text-[#FBBC04] text-xl md:text-2xl font-bold font-serif">
              {averageRating}
            </span>
            <StarRating rating={5} />
            <span className="text-white/50 text-xs">
              ({reviews.length} reseñas)
            </span>
          </div>
        </div>

        {/* Reviews Carousel */}
        <div className="relative">
          <div className="overflow-hidden">
            <div
              className="flex transition-transform duration-500 ease-in-out"
              style={{
                transform: `translateX(-${currentIndex * (100 / visibleCount)}%)`,
              }}
            >
              {reviews.map((review) => (
                <div
                  key={review.id}
                  className="flex-shrink-0 px-2"
                  style={{ width: `${100 / visibleCount}%` }}
                >
                  <div className="bg-[#14253D]/50 border border-white/8 rounded-2xl p-4 md:p-5 h-full flex flex-col">
                    {/* Google icon + stars */}
                    <div className="flex items-center justify-between mb-3">
                      <StarRating rating={review.rating} />
                      <span className="w-5 h-5 flex items-center justify-center opacity-40">
                        <i className="ri-google-fill text-white text-base"></i>
                      </span>
                    </div>

                    {/* Review text */}
                    <p className="text-white/75 text-xs md:text-sm leading-relaxed flex-1 mb-3 line-clamp-4">
                      &ldquo;{review.text}&rdquo;
                    </p>

                    {/* Author */}
                    <div className="flex items-center gap-2.5 pt-3 border-t border-white/10">
                      <div className="w-8 h-8 rounded-full bg-[#B89A5A]/20 flex items-center justify-center flex-shrink-0">
                        <span className="text-[#B89A5A] text-[10px] font-bold">
                          {review.avatar}
                        </span>
                      </div>
                      <div>
                        <p className="text-white text-xs font-semibold">
                          {review.name}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Navigation Arrows */}
          <button
            onClick={goPrev}
            className="absolute left-[-12px] md:left-[-18px] top-1/2 -translate-y-1/2 w-9 h-9 md:w-10 md:h-10 bg-[#14253D] border border-white/15 rounded-full flex items-center justify-center hover:border-[#B89A5A] transition-colors cursor-pointer z-10"
            aria-label="Anterior"
          >
            <i className="ri-arrow-left-s-line text-white text-lg"></i>
          </button>
          <button
            onClick={goNext}
            className="absolute right-[-12px] md:right-[-18px] top-1/2 -translate-y-1/2 w-9 h-9 md:w-10 md:h-10 bg-[#14253D] border border-white/15 rounded-full flex items-center justify-center hover:border-[#B89A5A] transition-colors cursor-pointer z-10"
            aria-label="Siguiente"
          >
            <i className="ri-arrow-right-s-line text-white text-lg"></i>
          </button>
        </div>

        {/* Dots */}
        <div className="flex items-center justify-center gap-1.5 mt-5">
          {Array.from({ length: maxIndex + 1 }).map((_, i) => (
            <button
              key={i}
              onClick={() => goTo(i)}
              className={`rounded-full transition-all duration-300 cursor-pointer ${
                i === currentIndex
                  ? 'w-6 h-1.5 bg-[#B89A5A]'
                  : 'w-1.5 h-1.5 bg-white/20 hover:bg-white/40'
              }`}
              aria-label={`Ir a reseña ${i + 1}`}
            />
          ))}
        </div>

        {/* CTA to Google */}
        <div className="text-center mt-5">
          <a
            href="https://www.google.com/maps/place/Jujuy+76,+X5022FMB+C%C3%B3rdoba/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 border border-[#B89A5A]/40 text-[#B89A5A] px-5 py-2.5 rounded-full text-xs font-medium hover:bg-[#B89A5A]/10 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-google-fill text-sm"></i>
            </span>
            Ver todas las reseñas en Google
          </a>
        </div>
      </div>
    </section>
  );
}
